'use strict';

import template from './mx-shell-breadcrumbs.html';
import { EventCodes } from '../../../../App/model/event-codes';

/**
 * @ngdoc directive
 * @name mx.shell:mxShellBreadcrumbs
 * @module mx.shell
 * @restrict 'E'
 * @scope {}
 * @requires {@ref mx.shell.EventService mx.shell.EventService}
 * @requires {@ref mx.shell.RoutingService mx.shell.RoutingService}
 * @requires {@ref mx.shell.NavigationService mx.shell.NavigationService}
 * @requires $scope
 * @description Application navigation breadcrumbs
 * @usage <mx-shell-breadcrumbs></mx-shell-breadcrumbs>
 */
angular.module('mx.shell').component('mxShellBreadcrumbs', {
	controller: MxShellBreadcrumbsCtrl,
	controllerAs: 'vm',
	template: template,
});

MxShellBreadcrumbsCtrl.$inject = ['$scope', 'mx.shell.EventService', 'mx.shell.RoutingService', 'mx.shell.NavigationService', 'mx.app.DeviceService'];

function MxShellBreadcrumbsCtrl($scope, eventService, routingService, navigationService, deviceService) {
	const vm = this;

	vm.deviceService = deviceService;

	vm.$onInit = function () {
		setBreadCrumbs(navigationService.currentItem, navigationService.extraItem);
	};

	vm.onItemClick = function ($event, it) {
		eventService.dispatchEvent(EventCodes.TrackTelemetry, {
			eventName: `Breadcrumb clicked`,
			sender: it.id,
			senderTitle: it.technicalName,
		});
		if (it.routingItem && it.routingItem.name) {
			routingService.go(it.route, it.parameters);
		}
	};

	eventService.subscribeTo(mx.shell.EventCodes.CurrentNavigationItemChanged, (event, { navigationItem, extraItem } = {}) => setBreadCrumbs(navigationItem, extraItem), $scope);

	return vm;

	function setBreadCrumbs(navigationItem, extraItem) {
		const items = [];

		if (navigationItem) {
			while (navigationItem.parent) {
				items.unshift(navigationItem);
				navigationItem = navigationItem.parent;
			}
			items.unshift(navigationItem);
		}

		if (extraItem) {
			items.push({
				name: extraItem,
				title: extraItem,
				children: [],
			});
		}
		vm.items = items;
	}
}
